import { FC, useState } from 'react'

import styled from 'styled-components'

import {
  useGetInboxDocumentsQuery,
  ApprovalStatusEnum,
} from 'src/Redux/api/documentsApi'
import { PageTitle } from 'src/Components/PageTitle/index.tsx'
import { DocumentApprovalModal } from 'src/Components/DocumentApprovalModal'
import { DocumentApprovalHistoryModal } from 'src/Components/DocumentApprovalHistoryModal'
import { SegmentedControl } from 'src/Components/Input/SegmentedControl'
import { device } from 'src/Helpers/constants'

import { InboxDocumentsList } from './InboxDocumentsList'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  position: relative;
  height: 100%;
  overflow: hidden;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;

  @media ${device.tabletMax} {
    gap: 16px;
  }
`

const FilterWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  width: 100%;
`

export const InboxPage: FC = () => {
  const [statusFilter, setStatusFilter] = useState<ApprovalStatusEnum | 'ALL'>(
    'ALL',
  )
  const [approvalModalOpened, setApprovalModalOpened] = useState(false)
  const [historyModalOpened, setHistoryModalOpened] = useState(false)
  const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(
    null,
  )
  const [selectedContractNumber, setSelectedContractNumber] = useState<
    string | null
  >(null)

  const { data: documentsResponse, isLoading } = useGetInboxDocumentsQuery({
    limit: 50,
    status: statusFilter === 'ALL' ? undefined : statusFilter,
  })

  const handleApprove = (documentId: string): void => {
    const document = documentsResponse?.documents.find(
      (d) => d.id === documentId,
    )
    setSelectedDocumentId(documentId)
    setSelectedContractNumber(document?.contract?.contractNumber || null)
    setApprovalModalOpened(true)
  }

  const handleReject = (documentId: string): void => {
    const document = documentsResponse?.documents.find(
      (d) => d.id === documentId,
    )
    setSelectedDocumentId(documentId)
    setSelectedContractNumber(document?.contract?.contractNumber || null)
    setApprovalModalOpened(true)
  }

  const handleViewHistory = (documentId: string): void => {
    const document = documentsResponse?.documents.find(
      (d) => d.id === documentId,
    )
    setSelectedDocumentId(documentId)
    setSelectedContractNumber(document?.contract?.contractNumber || null)
    setHistoryModalOpened(true)
  }

  return (
    <Container>
      <TitleWrapper>
        <PageTitle>Входящие документы</PageTitle>

        <FilterWrapper>
          <SegmentedControl
            value={statusFilter}
            onChange={(value) =>
              setStatusFilter(value as ApprovalStatusEnum | 'ALL')
            }
            data={[
              { label: 'Все', value: 'ALL' },
              {
                label: 'На согласовании',
                value: ApprovalStatusEnum.IN_PROCESS,
              },
              { label: 'Согласовано', value: ApprovalStatusEnum.APPROVED },
              { label: 'Отклонено', value: ApprovalStatusEnum.REJECTED },
            ]}
          />
        </FilterWrapper>
      </TitleWrapper>

      <InboxDocumentsList
        documents={documentsResponse?.documents}
        isLoading={isLoading}
        onApprove={handleApprove}
        onReject={handleReject}
        onViewHistory={handleViewHistory}
      />

      {selectedDocumentId && (
        <>
          <DocumentApprovalModal
            opened={approvalModalOpened}
            onClose={() => setApprovalModalOpened(false)}
            documentId={selectedDocumentId}
            contractNumber={selectedContractNumber || undefined}
          />
          <DocumentApprovalHistoryModal
            opened={historyModalOpened}
            onClose={() => setHistoryModalOpened(false)}
            documentId={selectedDocumentId}
            contractNumber={selectedContractNumber || undefined}
          />
        </>
      )}
    </Container>
  )
}
